"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function SvgComponent(props) {
    return React.createElement("svg", Object.assign({ viewBox: "0 0 512 512" }, props),
        React.createElement("path", { d: "M386.24,121.68a11,11,0,0,0-18.57-6L80,400l159.34,91.81a33.32,33.32,0,0,0,32.4,0L432,400Z" }),
        React.createElement("path", { d: "M221.32,136.68l0-.05-103,192.07a4,4,0,0,0,6.34,4.74L256.61,203l.5-.5Z" }),
        React.createElement("path", { d: "M207.19,129.06l5-9.39L160,21.92c-5.05-9.47-17.9-7.06-19.56,3.54L89.09,343.7a1.33,1.33,0,0,0,2.49.84h0Z" }),
        React.createElement("path", { d: "M235.37,129,269,190.77l32.47-32.09L265.26,90c-4.19-8-14.38-8.79-18.53-.81l-16.39,30.63,5,9.14Z" }));
}
exports.default = SvgComponent;
